import React from 'react';
import { Alert, Button } from '@mui/material';

/**
 * React Error Boundary component to catch render/runtime errors in the component tree and
 * display a user-friendly fallback. Implements §1.3 error-handling requirement.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log error details for debugging/analytics – could post to remote logging here.
    /* eslint-disable no-console */
    console.error('ErrorBoundary caught an error', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Alert severity="error" sx={{ m: 2 }}>
          Something went wrong. Please try again.
          <Button onClick={this.handleReload} sx={{ ml: 2 }} variant="outlined" size="small">
            Reload
          </Button>
        </Alert>
      );
    }
    // Render children normally when there is no error.
    return this.props.children;
  }
}

export default ErrorBoundary;
